import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { elementMatchesAny } from "../Global/tools.js";
import Type from "../Global/Typography.js";
import NanoFlex from "../Global/NanoFlex.js";
import Dropdown from "../Nano/Dropdown.js";
import Input from "../Nano/Input.js";

import { ReactComponent as ArrowUp } from "./../Global/Icons/arrowUp.svg";
import { ReactComponent as ArrowDown } from "./../Global/Icons/arrowDown.svg";
import { ReactComponent as Check } from "./../Global/Icons/check.svg";
import { ReactComponent as Delete } from "./../Global/Icons/delete.svg";
import { ReactComponent as SearchIcon } from "./../Global/Icons/search.svg";

const multiple = nota.global.multiple;
const mainWidth = multiple * 25; /* 200px */
const StyledBlockBox = styled.div`
  width: 100%;
  height: ${multiple * 4 + "px"}; /* 32px */
  padding: ${multiple + "px"}; /* 8px */
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  .dropDownLine {
    svg {
      width: 15px;
      height: 10px;
      path {
        fill: ${(props) => (props.selected ? nota.color.main.default : nota.color.neutral.NeuThree)};
      }
    }
    p {
      margin-left: ${multiple + "px"}; /* 8px */
      font-weight: ${(props) => (props.selected ? `bold` : `normal`)};
      width: 100%;
      /* overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; */
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .deleteIcon {
      width: 25px;
      padding: 16px 0px;
      svg {
        height: 12px;
      }
      &:hover {
        svg {
          path {
            fill: ${nota.color.main.mTwo};
          }
        }
      }
    }
  }
  &:first-child {
    background-color: ${nota.color.neutral.NeuFour};
  }
  &:hover {
    background-color: ${nota.color.neutral.NeuFour};
  }
`;

const BlockBox = (props) => (
  <StyledBlockBox
    onClick={(e) => {
      /*Prevent Click on Delete Icon*/
      if (elementMatchesAny(e.target, [".deleteIcon"])) return;
      return props.blockBoxAction(props.index);
    }}
    selected={props.selected}>
    {props.content && (
      <NanoFlex className="dropDownLine" justifyContent={"flex-start"}>
        <Check />
        <Type.p>{props.content}</Type.p>
        {props.delete && (
          <NanoFlex className="deleteIcon" onClick={() => props.deleteAction()}>
            <Delete />
          </NanoFlex>
        )}
      </NanoFlex>
    )}
  </StyledBlockBox>
);

const StyledSingleSelectionDropdown = styled.div`
  width: ${multiple * 29 + "px"};
  border: 1px solid ${(props) => (props.error ? nota.color.main.mTwo : nota.color.neutral.NeuTwo)};
  font-size: 12px;
  color: ${nota.color.neutral.NeuOne};
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  .dropDownWrapper {
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    .inputDropDownWrapper {
      width: 100%;
      min-width: ${mainWidth + "px"};
      height: ${multiple * 4 + "px"}; /* 32px */
      .infoDropDownWrapper {
        width: calc(100% - 18px);
        padding: 0 10px;
        p {
          color: ${(props) => (props.displayString ? nota.color.neutral.NeuOne : nota.color.neutral.NeuTwo)};
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .iconDropDownWrapper {
        background-color: ${(props) => (props.indicator ? nota.color.main.mOne : nota.color.main.default)};
        width: 18px;
        padding: 5px;
        svg {
          height: 15px;
          width: 15px;
        }
        .svgMargin {
          margin-top: 2px;
        }
      }
    }
    .dropdown-content {
      margin: 0;
      border: 1px solid ${nota.color.neutral.NeuTwo};
      width: calc(100% + 2px);
      min-height: auto;
      max-height: 200px;
      overflow: auto;
    }
  }

  .inputSearchWrapper {
    position: relative;
    min-height: -webkit-fit-content;
    div {
      margin: 0;
      width: 100%;
      input {
        border: 0;
        border-bottom: 1px solid ${nota.color.neutral.NeuTwo};
        padding: ${multiple + "px"};
        padding-right: 40px;
      }
    }
    .searchIconWrapper {
      position: absolute;
      height: auto;
      right: ${multiple + "px"};
      width: ${multiple * 3 + "px"};
      svg {
        width: 14px;
        height: 14px;
        path {
          fill: ${nota.color.neutral.NeuTwo};
        }
      }
    }
  }
  .noResults {
    padding: ${multiple + "px"};
  }
`;

class SingleSelectionDropdown extends BaseComponent {
  constructor(props) {
    super(props);
    let options = this.props.options ? this.props.options : [];
    this.state = {
      term: "",
      options: options,
      selected: this.props.selected,
      isOpenDropdown: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected !== this.state.selected) {
      this.triggerOnChangeSelection();
    }
    if (JSON.stringify(prevProps.selected) !== JSON.stringify(this.props.selected) || this.props.forceSelection) {
      this.setState({ selected: this.props.selected });
    }
    if (prevProps.options !== this.props.options) {
      this.setState({ options: this.props.options });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  triggerOnChangeSelection = () => {
    if (this.props.onChangeSelection) {
      this.props.onChangeSelection(
        this.state.options.find((v) => {
          return this.state.selected == v.id;
        })
      );
    }
  };

  onOptionClick = (v) => {
    this.setState({
      selected: this.state.selected !== v ? v : null,
      isOpenDropdown: false,
    });
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  getDisplayString = () => {
    if (!this.state.selected) return "";

    return this.state.options.find((v) => {
      return this.state.selected == v.id;
    }).name;
  };

  getFilteredResults = () => {
    if (this.state.term.trim() !== "") {
      let upperTerm = this.state.term.trim().toUpperCase();
      return this.state.options.filter((v) => {
        let upperName = v.name.trim().toUpperCase();
        return upperName.includes(upperTerm);
      });
    } else {
      return this.state.options;
    }
  };

  render() {
    let displayString = this.getDisplayString();
    let filteredResults = this.getFilteredResults();
    return (
      <StyledSingleSelectionDropdown className="dropDownContainer" displayString={displayString} indicator={this.state.selected} error={this.props.error}>
        <NanoFlex className="dropDownWrapper">
          <Dropdown
            isOpen={this.state.isOpenDropdown}
            onClickOutsideClose
            main={
              <NanoFlex className="inputDropDownWrapper" justifyContent={"flex-start"} alignItems={"flex-start"}>
                <NanoFlex className="infoDropDownWrapper" justifyContent={"flex-start"}>
                  <Type.p>{displayString ? displayString : this.translation.geral.selectAnOption}</Type.p>
                </NanoFlex>
                <NanoFlex className="iconDropDownWrapper">{this.state.isOpenDropdown ? <ArrowUp /> : <ArrowDown className="svgMargin" />}</NanoFlex>
              </NanoFlex>
            }
            content={
              <NanoFlex flexDirection={"column"} justifyContent={"flex-start"}>
                <NanoFlex className="inputSearchWrapper">
                  <Input title={null} defaultValue={this.state.term} placeholder={this.translation.geral.search + "..."} onChangeAction={this.onTermChange} />
                  <NanoFlex className="searchIconWrapper">
                    <SearchIcon />
                  </NanoFlex>
                </NanoFlex>
                {filteredResults.length == 0 && (
                  <NanoFlex className="noResults">
                    <Type.p>No Results Found</Type.p>
                  </NanoFlex>
                )}
                {filteredResults.map((v, i) => {
                  return (
                    <BlockBox
                      key={`SingleItem_${v.id}`}
                      content={v.name}
                      selected={this.state.selected === v.id}
                      blockBoxAction={() => {
                        this.onOptionClick(v.id);
                      }}
                      delete={this.props.onDeleteClick ? true : false}
                      deleteAction={() => {
                        this.props.onDeleteClick(v.id);
                      }}
                    />
                  );
                })}
              </NanoFlex>
            }
            onChangeToggle={(isOpen) => this.setState({ isOpenDropdown: isOpen })}
          />
        </NanoFlex>
      </StyledSingleSelectionDropdown>
    );
  }
}

export default SingleSelectionDropdown;
// --- // Documentation // --- //
/*
import SingleSelectionDropdown from './../Nano/SingleSelectionDropdown.js';
<SingleSelectionDropdown
    options={ [] }
    onChangeSelection={(id) => console.log(id)}
/>
*/
